import { connect } from 'react-redux'

import animateScrollTo from 'animated-scroll-to'

import GotoTop from './units'

const mapStateToProps = state => ({
  offset: state.GotoTop.offset,
  options: state.GotoTop.options,
})

const mapDispatchToProps = () => ({
  handleGotoTop(offset, options) {
    animateScrollTo(offset, options)
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GotoTop)
